import { Copy } from 'lucide-react';
import { toast } from 'sonner';

import { Button } from '@/components/ui/button';

interface CopyAsTextButtonProps {
    /** Builds the text at click time, so it holds what is on screen then. */
    getText: () => string;
    testId: string;
}

export function CopyAsTextButton({ getText, testId }: CopyAsTextButtonProps) {
    const copy = async () => {
        try {
            await navigator.clipboard.writeText(getText());
            toast.success('Copied');
        } catch {
            toast.error('Could not copy. Try again or copy it by hand.');
        }
    };
    return (
        <Button
            type="button"
            variant="outline"
            size="sm"
            className="h-8 shrink-0 text-xs"
            onClick={() => void copy()}
            data-testid={testId}
        >
            <Copy className="mr-1 h-3.5 w-3.5" />
            Copy as text
        </Button>
    );
}
